export default __webpack_public_path__ + "static/media/SuiteX60s.050e162a.mp3";